import { Lookup } from "@data-types";
import { EstimatedGamingAmountDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformEstimatedGamingAmountsApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/estimated-gaming-amounts`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findEstimatedGamingAmount(): Promise<
		Lookup<EstimatedGamingAmountDataType>
	> {
		const response = await retryRequest(() =>
			httpClient.get(`${this.baseUrl}`, this.getRequestHeaders())
		);

		return response;
	}
}

export default PlatformEstimatedGamingAmountsApiService;
